import { getConciliationAdjustmentDisplay } from '../../utils/conciliationAdjustmentDisplay'

export default function ConciliationAdjustmentAmount({ movement, documentTotal, formatCurrency }) {
  const detail = getConciliationAdjustmentDisplay(movement, documentTotal)
  if (!detail) return null
  return (
    <div className='flex shrink-0 flex-col items-end gap-1 py-1 text-right whitespace-nowrap'>
      <span className='text-[13px] font-semibold leading-tight'>{formatCurrency(detail.total)}</span>
      <div className='flex items-center gap-2 text-[11px] leading-tight text-gray-500'>
        <span>{detail.label}</span>
        <span className='font-medium tabular-nums'>{detail.adjustment > 0 ? '+' : detail.adjustment < 0 ? '−' : ''}{formatCurrency(Math.abs(detail.adjustment))}</span>
      </div>
    </div>
  )
}
